import React from "react"
import moment from "moment"

export function formatSeminarSchedule(seminar) {
    if (!seminar) return ""
    const parts = []
    const day = seminar.selectDay || seminar.day || (seminar.seminarDate ? moment(seminar.seminarDate).format("dddd") : "")
    const formattedDate = seminar.seminarDate
        ? moment(seminar.seminarDate).format("DD MMMM YYYY")
        : (seminar.fromDate ? moment(seminar.fromDate, ["DD MMM YYYY", "YYYY-MM-DD", "DD/MM/YYYY", "YYYY-MM-DDTHH:mm:ss"]).format("DD MMMM YYYY") : "")

    const dateStr = day && formattedDate ? `${day}, ${formattedDate}` : (formattedDate || day)

    if (dateStr) {
        parts.push(dateStr)
    }

    const startTime = seminar.startTime ? moment(seminar.startTime, ["HH:mm:ss", "HH:mm"]).format("hh:mm A") : ""
    const endTime = seminar.endTime ? moment(seminar.endTime, ["HH:mm:ss", "HH:mm"]).format("hh:mm A") : ""

    if (startTime && endTime) {
        parts.push(`${startTime}–${endTime} (India)`)
    } else if (startTime) {
        parts.push(`${startTime} (India)`)
    }

    return parts.join(" | ")
}

export const PastSeminarCard = ({ seminar, onClick }) => {
    if (!seminar) return null
    const scheduleText = formatSeminarSchedule(seminar)

    return (
        <article
            aria-labelledby={`past-seminar-${seminar.seminarID}`}
            className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden d-flex flex-column"
            style={{
                backgroundColor: "#f5f7f8",
                borderTop: "4px solid #cd9e53",
                transition: "transform 0.25s ease, box-shadow 0.25s ease",
                cursor: onClick ? "pointer" : "default",
            }}
            onClick={() => {
                if (onClick) onClick(seminar)
            }}
            role={onClick ? "button" : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={(e) => {
                if (onClick && (e.key === "Enter" || e.key === " ")) {
                    e.preventDefault()
                    onClick(seminar)
                }
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)"
                e.currentTarget.style.boxShadow = "0 12px 24px rgba(22, 55, 78, 0.15)"
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)"
                e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
            }}
        >
            {/* Thumbnail */}
            <div
                className="position-relative overflow-hidden"
                style={{
                    height: "260px",
                    backgroundColor: "#16374e",
                }}
            >
                <img
                    src={seminar.sidePhotoPath || seminar.sidePicView || seminar.seminarPhotoPath || seminar.seminarPicView || "/Static/Assets/Img/Seminar_Img.jpeg"}
                    alt={seminar.title || "Past seminar"}
                    onError={(e) => {
                        e.currentTarget.onerror = null
                        e.currentTarget.src = "/Static/Assets/Img/Seminar_Img.jpeg"
                    }}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                />
                <span
                    className="badge rounded-pill position-absolute top-0 start-0 m-3 px-3 py-2 shadow-sm"
                    style={{
                        backgroundColor: "#16374e",
                        color: "#cd9e53",
                        fontSize: "12px",
                        fontWeight: 600,
                        border: "1px solid rgba(205, 158, 83, 0.4)",
                    }}
                >
                    Past seminar
                </span>
            </div>

            {/* Card Content */}
            <div className="card-body d-flex flex-column p-4 flex-grow-1">
                {scheduleText && (
                    <div
                        className="fw-bold mb-2 small text-uppercase"
                        style={{ color: "#cd9e53", letterSpacing: "0.5px" }}
                    >
                        {scheduleText}
                    </div>
                )}

                <h3
                    id={`past-seminar-${seminar.seminarID}`}
                    className="fw-bold mb-3"
                    style={{
                        color: "#16374e",
                        fontSize: "18px",
                        lineHeight: "1.4",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        minHeight: "48px",
                    }}
                    title={seminar.title}
                >
                    {seminar.title}
                </h3>

                <div className="mt-auto pt-3 border-top d-flex align-items-center justify-content-between text-muted small">
                    <span style={{ color: "#16374e", fontWeight: 600 }}>View Details</span>
                    <span style={{ color: "#cd9e53", fontSize: "16px", fontWeight: "bold" }}>→</span>
                </div>
            </div>
        </article>
    )
}
export default PastSeminarCard
